import * as moment from 'moment-timezone';
import * as momentTz from 'moment-timezone';

/**
 * Allows to construct a Moment with the given attributes.
 * @remarks we use timezone name instead of timezone offset, because offset change with DST.
 */
export default class DateUtils {
  static createDate({
    year,
    month,
    date,
    hour,
    minute,
    second,
    timezone,
  }: {
    year: number;
    month: number;
    date: number;
    hour: number;
    minute: number;
    second: number;
    timezone?: string;
  }): momentTz.Moment {
    let result = momentTz();
    if (timezone) {
      result = result.tz(timezone);
    }
    result.set({ year, month, date, hour, minute, second, millisecond: 0 });
    return result;
  }

  static formatDateRangePicker(dateRange: { start: moment.Moment; end: moment.Moment }) {
    const { start, end } = dateRange;
    const formatMomentDate = (momentDate: moment.Moment, end?: boolean) => {
      const result = moment.utc();
      if (end) {
        const [year, month, date] = momentDate.toArray();
        result.set({ year, month, date, hour: 23, minute: 59, second: 59, millisecond: 0 });
        return result.toISOString();
      }
      const [year, month, date, hour, minute, second] = momentDate.toArray();
      result.set({ year, month, date, hour, minute, second, millisecond: 0 });
      return result.toISOString();
    };
    return {
      start: formatMomentDate(start),
      end: formatMomentDate(end || start, true),
    };
  }
}
